import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
//import online from "./images/green-button-badge.jpg"
import MainPage from "./components/MainPageComponent";
import ReactGA from "react-ga";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Page404Component from "./components/Page404";
ReactGA.initialize("G-5JD2P5C978");

class App extends React.Component {
  componentDidMount() {
    ReactGA.pageview("HOME");
  }
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route path="/" exact component={MainPage} />
            <Route path="*" exact component={Page404Component} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
